// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","overlay":"modal-overlay_overlay__BZsXG"};